import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  position: sticky;
  top: 0;
  z-index: 1000;
`;

const Logo = styled.img`
  height: 110px;
  width: auto;
  object-fit: cover;
`;

const Nav = styled.nav`
  display: flex;
  gap: 2rem;
  align-items: center;

  @media (max-width: 768px) {
    display: none;
  }
`;

const NavLink = styled(Link)`
  color: #646163;
  font-weight: 500;
  text-transform: uppercase;
  font-size: 0.9rem;
  letter-spacing: 0.5px;

  &:hover {
    color: #7AA6A2;
  }
`;

const CtaButton = styled(Link)`
  background-color: var(--accent-color, #C4973A);
  color: white;
  padding: 0.6rem 1.4rem;
  border-radius: 100px;
  font-weight: 700;
  font-size: 0.85rem;
  transition: background-color 0.2s, transform 0.15s;

  &:hover {
    background-color: #a87e2e;
    color: white;
    opacity: 1;
    transform: translateY(-1px);
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const HamburgerButton = styled.button`
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  color: #646163;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 5px;
  }
`;

const HamburgerLine = styled.span`
  display: block;
  width: 24px;
  height: 2px;
  background-color: #646163;
  border-radius: 2px;
  transition: all 0.2s ease;
`;

const MobileMenu = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: ${({ open }) => (open ? 'flex' : 'none')};
    flex-direction: column;
    gap: 0;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: #fff;
    box-shadow: 0 4px 8px rgba(0,0,0,0.08);
    padding: 1rem 0;
    z-index: 999;
  }
`;

const MobileNavLink = styled(Link)`
  color: #646163;
  font-weight: 500;
  text-transform: uppercase;
  font-size: 0.9rem;
  letter-spacing: 0.5px;
  padding: 0.85rem 2rem;
  border-bottom: 1px solid #f0f0f0;

  &:hover {
    color: #7AA6A2;
    background-color: #f9f9f9;
  }

  &:last-child {
    border-bottom: none;
  }
`;

const MobileCtaButton = styled(Link)`
  background-color: var(--accent-color, #C4973A);
  color: white;
  margin: 1rem 2rem 0.5rem;
  padding: 0.75rem 1.2rem;
  border-radius: 100px;
  font-weight: 700;
  font-size: 0.85rem;
  text-align: center;
  transition: background-color 0.2s;

  &:hover {
    background-color: #a87e2e;
    color: white;
  }
`;

const NAV_LINKS = [
  { label: 'Home', to: '/' },
  { label: 'Workshops', to: '/workshops' },
  { label: 'Ministry Incubators', to: '/ministry-incubators' },
  { label: 'Events', to: '/events' },
  { label: 'Resources', to: '/resources' },
  { label: 'About', to: '/about' },
];

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <HeaderContainer style={{ position: 'sticky', flexWrap: 'wrap' }}>
      <Link to="/">
        <Logo src="/img/logo_2025_mvp.jpg" alt="Building on Truth Logo" />
      </Link>

      <Nav>
        {NAV_LINKS.map(({ label, to }) => (
          <NavLink key={to} to={to}>{label}</NavLink>
        ))}
      </Nav>

      <CtaButton to="/contact">Contact Us</CtaButton>

      <HamburgerButton
        onClick={() => setMenuOpen((o) => !o)}
        aria-label={menuOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={menuOpen}
      >
        <HamburgerLine />
        <HamburgerLine />
        <HamburgerLine />
      </HamburgerButton>

      <MobileMenu open={menuOpen}>
        {NAV_LINKS.map(({ label, to }) => (
          <MobileNavLink key={to} to={to} onClick={closeMenu}>{label}</MobileNavLink>
        ))}
        <MobileCtaButton to="/contact" onClick={closeMenu}>Contact Us</MobileCtaButton>
      </MobileMenu>
    </HeaderContainer>
  );
};

export default Header;
